import styled from 'styled-components'

type DropdownIconProps = {
  className?: string
}

const DropdownIcon = ({ className }: DropdownIconProps) => (
  <DropdownIconContainer className={className}>
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6L8 11L2 6"
        stroke="#333333"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </DropdownIconContainer>
)

const DropdownIconContainer = styled.div`
  width: 16px;
  height: 16px;
`

export default DropdownIcon
